import { valuesFormatter } from "~/EasyProjects/Common/ValuesFormatter";
import { InlineEditSwitcherAdapter } from "~/sharedComponents/inlineEdit/InlineEditSwitcherAdapter";
import { withEditMode } from "../../sharedHOC/withEditMode/withEditMode";
import { withValidation } from "../../sharedHOC/withValidation/withValidation";
// eslint-disable-next-line @logicsoftware/ep-custom/no-cross-feature-imports
import { DatePickerView } from "../../SystemLists/components/publicHolidays/DatePickerView";
import { HyperlinkValueViewer } from "../hyperlink/hyperlinkValueViewer";
import {
    DatepickerInput,
    dateViewerFormatter,
    Input,
    inputTheme,
    MultilineInput,
    TextArea,
    textareaTheme,
} from "../inputs";
import { getItemName, getItemValue, NamedItem, NamedItemKey } from "../list";
import { InlinePopupSelectPlain, InlinePopupSelectPlainType, InlinePopupSelectVirt } from "../select";
import { inlineEditMultiSelectDefaultProps } from "./const";
import { InlineEditCheckboxAdapter } from "./InlineEditCheckboxAdapter";
import { InlineMultiSelect } from "./InlineMultiSelect";
import { NumberInput } from "./NumberInput";
import { withInlineEdit } from "./withInlineEdit";

export const InlineEditCheckbox = withInlineEdit(withEditMode(InlineEditCheckboxAdapter), {
    saveOnChange: true,
    alwaysEditMode: true,
    hideUpdatingIndicator: true,
    ignoreDescription: true,
});

export const InlineEditSwitcher = withInlineEdit(withEditMode(InlineEditSwitcherAdapter), {
    saveOnChange: true,
    alwaysEditMode: true,
    hideUpdatingIndicator: true,
    ignoreDescription: true,
    isInlineField: false,
});

export const InlineEditHyperlink = withInlineEdit(withValidation(withEditMode(Input)), {
    alwaysEditMode: false,
    theme: inputTheme.custom_field,
    valueViewer: HyperlinkValueViewer,
    autoFocus: true,
});

export const InlineEditInput = withInlineEdit(withValidation(withEditMode(Input)), {
    alwaysEditMode: true,
});

export const InlineEditMultilineInput = withInlineEdit(withValidation(withEditMode(MultilineInput)), {
    alwaysEditMode: true,
    theme: textareaTheme.details_input,
    selectOnFocus: true,
});

export const InlineFormulaMultilineInput = withInlineEdit(withValidation(withEditMode(MultilineInput)), {
    valueFormatter: (val: number) => valuesFormatter.formatDecimal(val),
    disabled: true,
    theme: textareaTheme.details_input,
    selectOnFocus: true,
});

export const InlineEditTextArea = withInlineEdit(withValidation(withEditMode(TextArea)), {
    alwaysEditMode: true,
    isAutoResize: true,
    updateOnCtrlEnter: true,
    theme: textareaTheme.details_input,
    selectOnFocus: false,
});

export const InlineAlwaysEditDatePicker = withInlineEdit(withValidation(withEditMode(DatepickerInput)), {
    isInlineField: false,
    hideErrorMsg: true,
    options: { autoOpen: true },
    valueViewer: DatePickerView,
    treatAsEmpty: (val: any) => val === "",
    isRequired: true,
});

export const InlineEditDatepicker = withInlineEdit(withValidation(withEditMode(DatepickerInput)), {
    valueFormatter: dateViewerFormatter,
    autoFocus: true,
    theme: inputTheme.custom_field,
    options: {
        autoOpen: true,
    },
});

export const InlineEditNumberInput = withInlineEdit(withValidation(withEditMode(NumberInput)), {
    selectOnFocus: true,
    alwaysEditMode: true,
    theme: inputTheme.custom_field,
    treatNullAsZero: false,
});

export const InlineSelectDefaultProps = {
    saveOnChange: true,
    alwaysEditMode: false,
    inlineSearch: true,
    disableAutoReset: true,
    searchInputTheme: inputTheme.custom_field,
};

export const InlineEditSelect = withInlineEdit(
    withValidation(withEditMode(InlinePopupSelectVirt as InlinePopupSelectPlainType<NamedItem, NamedItemKey>)),
    {
        ...InlineSelectDefaultProps,
        getItemLabel: getItemName,
        valueSelector: getItemValue,
    }
);

export const InlineEditPlainSelect = withInlineEdit(
    withValidation(withEditMode(InlinePopupSelectPlain as InlinePopupSelectPlainType<NamedItem, NamedItemKey>)),
    {
        ...InlineSelectDefaultProps,
        getItemLabel: getItemName,
        valueSelector: getItemValue,
    }
);

/**
 * @deprecated use Multiselect instead this.
 */
export const InlineEditMultiSelect = withInlineEdit(
    withValidation(withEditMode(InlineMultiSelect)),
    inlineEditMultiSelectDefaultProps
);
